export default __webpack_public_path__ + "static/media/solicitacao_de_retorno.ce43f93b.mp4";